import {
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Collapse,
  Divider,
  Flex,
  Input,
  Popconfirm,
  Result,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import api from "../../../../../api";
import Colors from "../../../../../assets/styles/Colors";
import Loader from "../../../../../components/Loader";
import { IntTplPackage } from "../../../../../domain/types";
import { useAppSelector } from "../../../../../store";
import { AppState } from "../../../../../store/appSlice";
import DocumentFieldUploader from "../../../../admin_components/DocumentFieldUploader";
const { Text } = Typography;

interface DataType {
  key: string;
  label: string;
}

const AdminInternationalTplPackageEdit: React.FC<{
  productId?: number;
  onPackageUpdate?: () => void;
}> = ({ productId, onPackageUpdate }) => {
  const _dateID = dayjs().format("DD / MM / YYYY | HH:mm:ss");
  const { t } = useTranslation();

  const { lang, field_Language } = useAppSelector(
    (data: { app: AppState }) => data.app,
  );
  const _stateInitData = {
    translations: {
      ge: {
        title: `სატესტო დასახელება - ${_dateID}`,
      },
      en: {
        title: `Test name - ${_dateID}`,
      },
    },
  };

  const [packagesState, setPackagesState] =
    useState<Partial<IntTplPackage>>(_stateInitData);
  console.log("packagesState", packagesState);

  // ####################################################################
  const [createPackage, { isLoading: isCreatePackageLoading }] =
    api.useCreateIntTplPackageMutation();

  const [updatePackage, { isLoading: isUpdatePackageLoading }] =
    api.useUpdateIntTplPackageMutation();

  const [deletePackage, { isLoading: isDeletePackageLoading }] =
    api.useDeleteIntTplPackageMutation();

  const {
    data: packages,
    isLoading: isPackagesLoading,
    refetch: refetchPackages,
  } = api.useGetIntTplPackagesQuery(productId as number, {
    skip: !productId,
  });

  const { data: daysList, isLoading: isDaysListLoading } =
    api.useGetIntTplDaysQuery(undefined);

  const { data: clientTypes, isLoading: clientTypesLoading } =
    api.useGetClientTypesQuery(undefined);

  const { data: paymentSchedule, isLoading: isPaymentScheduleLoading } =
    api.useGetPaymentScheduleTypesQuery(undefined);

  const {
    data: IntTplClientTypesList,
    isLoading: isIntTplClientTypeListLoading,
  } = api.useGetIntTplClientTypesQuery(undefined);

  const {
    data: IntTplClientDodumentTypesList,
    isLoading: isIntTplClientDocumentTypeListLoading,
  } = api.useGetIntTplClientTDocumentypesQuery(undefined);

  // used
  const { data: IntTplPurposeList, isLoading: isIntTplPurposeLoading } =
    api.useGetIntTplPurposeQuery(undefined);

  const { data: IntTplVehicleTypeList, isLoading: isIntTplVehicleTypeLoading } =
    api.useGetIntTplVehicleTypeQuery(undefined);

  const {
    data: IntTplVehicleDodumentTypesList,
    isLoading: isIntTplVehicleDocumentTypesLoading,
  } = api.useGetIntTplVehicleDocumentypesQuery(undefined);

  // ####################################################################

  // ###################################
  const _createPackage = async () => {
    try {
      await createPackage({
        pkg: _stateInitData as IntTplPackage,
        productId: productId as number,
      }).unwrap();
      refetchPackages();
      onPackageUpdate?.();
      toast.success(`${t("package")} ${t("createdSuccessfully")}`);
    } catch (error) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0];
        const errorMessage = firstError.message;
        toast.error(errorMessage);
      } else {
        toast.error(`${t("errorOccurred")}`);
      }
    }
  };

  const _UpdatePackage = async () => {
    try {
      await updatePackage({
        pkg: {
          ...packagesState,
          target: sanitizeTarget(packagesState.target),
          status: "draft",
        },
        productId: productId as number,
      }).unwrap();
      refetchPackages();
      onPackageUpdate?.();
      toast.success(`${t("package")} ${t("updatedSuccessfully")}`);
    } catch (error) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0];
        const errorMessage = firstError.message;
        toast.error(errorMessage);
      } else {
        toast.error(`${t("errorOccurred")}`);
      }
    }
  };

  const _activePackageStatus = async (status: string) => {
    try {
      await updatePackage({
        pkg: {
          ...packagesState,
          target: sanitizeTarget(packagesState.target),
          status,
        },
        productId: productId as number,
      }).unwrap();
      refetchPackages();
      onPackageUpdate?.();
      toast.success(`${t("status")} ${t("updatedSuccessfully")}`);
    } catch (error) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0];
        const errorMessage = firstError.message;
        toast.error(errorMessage);
      } else {
        toast.error(`${t("errorOccurred")}`);
      }
    }
  };

  const _deletePackage = async (packageID?: number) => {
    try {
      await deletePackage({
        packageId: packageID as number,
        productId: productId as number,
      }).unwrap();
      refetchPackages();
      onPackageUpdate?.();
      toast.success(`${t("package")} ${t("deletedSuccessfully")}`);
    } catch (error) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0];
        const errorMessage = firstError.message;
        toast.error(errorMessage);
      } else {
        toast.error(`${t("errorOccurred")}`);
      }
    }
  };

  const updatePackageField = (
    field: keyof Partial<IntTplPackage>,
    value: any,
  ) => {
    setPackagesState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updatePackageTargetField = (
    field: keyof Partial<IntTplPackage["target"]>,
    value: any,
  ) => {
    setPackagesState((prev) => ({
      ...prev,
      target: {
        ...prev.target,
        [field]: value,
      } as IntTplPackage["target"],
    }));
  };
  // ###################################

  const normalizeNumberArray = (values: Array<string | number>) =>
    values.map(Number).filter((value) => !Number.isNaN(value));

  const safeArray = (value: unknown): Array<string | number> =>
    Array.isArray(value) ? value : [];

  const safeNumberArray = (value: unknown): number[] =>
    normalizeNumberArray(safeArray(value));

  const sanitizeTarget = (
    target?: Partial<IntTplPackage["target"]>,
  ): IntTplPackage["target"] => ({
    clientDocumentTypeIds: safeNumberArray(target?.clientDocumentTypeIds),
    clientDocumentTypes: safeNumberArray(target?.clientDocumentTypes),
    clientSubtypeIds: safeNumberArray(target?.clientSubtypeIds),
    clientTypeIds: safeNumberArray(target?.clientTypeIds),
    clientTypes: safeNumberArray(target?.clientTypes),
    insurancePeriods: safeNumberArray(target?.insurancePeriods),
    insurancePeriodIds: safeNumberArray(target?.insurancePeriodIds),
    vehicleDocumentTypeIds: safeNumberArray(target?.vehicleDocumentTypeIds),
    vehicleTypeIds: safeNumberArray(target?.vehicleTypeIds),
    usageTypeIds: safeNumberArray(target?.usageTypeIds),
  });

  const mergeGroupSelection = (
    current: number[],
    groupIds: number[],
    nextGroupValues: Array<string | number>,
  ) => {
    const normalized = normalizeNumberArray(nextGroupValues);
    const groupIdSet = new Set(groupIds);
    const filteredCurrent = current.filter((id) => !groupIdSet.has(id));
    return Array.from(new Set([...filteredCurrent, ...normalized]));
  };

  const [usageTypeSelectionsByClient, setUsageTypeSelectionsByClient] =
    useState<Record<number, number[]>>({});

  const [
    clientDocumentTypeSelectionsByClient,
    setClientDocumentTypeSelectionsByClient,
  ] = useState<Record<number, number[]>>({});

  useEffect(() => {
    if (!clientTypes || !IntTplPurposeList) {
      setUsageTypeSelectionsByClient({});
      return;
    }

    const packageId = packagesState?.id;
    if (!packageId || typeof window === "undefined") {
      setUsageTypeSelectionsByClient({});
      return;
    }

    const storageKey = `intlTplPkgUsageTypeSelectionsByClient:${packageId}`;
    const storedRaw = window.localStorage.getItem(storageKey);
    if (storedRaw) {
      try {
        const parsed = JSON.parse(storedRaw) as Record<string, number[]>;
        const sanitized: Record<number, number[]> = {};
        Object.entries(parsed).forEach(([key, value]) => {
          sanitized[Number(key)] = safeNumberArray(value);
        });
        setUsageTypeSelectionsByClient(sanitized);
        return;
      } catch {
        window.localStorage.removeItem(storageKey);
      }
    }

    const selectedPurposeIds = safeNumberArray(
      packagesState?.target?.usageTypeIds,
    );
    const nextSelections: Record<number, number[]> = {};

    clientTypes.forEach((client) => {
      const relatedPurposes = IntTplPurposeList?.filter(
        (purpose) =>
          purpose.status === "active" &&
          purpose.clientTypeIds?.includes(client.id),
      );
      const selectedIds = relatedPurposes
        ?.filter((purpose) => selectedPurposeIds?.includes(purpose.id))
        .map((purpose) => purpose.id);

      if (selectedIds?.length) {
        nextSelections[client.id] = selectedIds;
      }
    });

    window.localStorage.setItem(storageKey, JSON.stringify(nextSelections));
    setUsageTypeSelectionsByClient(nextSelections);
  }, [packagesState?.id, clientTypes, IntTplPurposeList]);

  const handleUsageTypeChange = (
    clientId: number,
    values: Array<string | number>,
  ) => {
    const nextValues = normalizeNumberArray(values);

    setUsageTypeSelectionsByClient((prev) => {
      const nextSelections = {
        ...prev,
        [clientId]: nextValues,
      };

      if (process.env.NODE_ENV !== "production") {
        Object.keys(prev).forEach((key) => {
          const otherClientId = Number(key);
          if (
            otherClientId !== clientId &&
            prev[otherClientId] !== nextSelections[otherClientId]
          ) {
            // Guard: ensure updates are isolated per client type.
            console.info("[usageType] other client selection mutated", {
              clientId,
              otherClientId,
            });
          }
        });
      }

      const flattenedPurposeIds = Object.values(nextSelections).flat();
      const uniquePurposeIds = Array.from(new Set(flattenedPurposeIds));
      updatePackageTargetField("usageTypeIds", uniquePurposeIds);

      const packageId = packagesState?.id;
      if (packageId && typeof window !== "undefined") {
        const storageKey = `intlTplPkgUsageTypeSelectionsByClient:${packageId}`;
        window.localStorage.setItem(storageKey, JSON.stringify(nextSelections));
      }

      return nextSelections;
    });
  };

  const handleClientTypeChange = (values: Array<string | number>) => {
    const nextClientTypeIds = normalizeNumberArray(values);
    const allowedSubtypeIds =
      IntTplClientTypesList?.filter((item) =>
        nextClientTypeIds.includes(item.clientTypeId),
      ).map((item) => item.id) || [];
    const allowedDocumentTypeIds =
      IntTplClientDodumentTypesList?.filter((item) =>
        nextClientTypeIds.includes(item.clientTypeId),
      ).map((item) => item.id) || [];

    setPackagesState((prev) => ({
      ...prev,
      target: {
        ...prev.target,
        clientTypeIds: nextClientTypeIds,
        clientSubtypeIds: (prev.target?.clientSubtypeIds || []).filter((id) =>
          allowedSubtypeIds.includes(id),
        ),
        clientDocumentTypeIds: (
          prev.target?.clientDocumentTypeIds || []
        ).filter((id) => allowedDocumentTypeIds.includes(id)),
      } as IntTplPackage["target"],
    }));

    setUsageTypeSelectionsByClient((prev) => {
      const next: Record<number, number[]> = {};
      nextClientTypeIds.forEach((id) => {
        if (prev[id]) next[id] = prev[id];
      });
      return next;
    });

    setClientDocumentTypeSelectionsByClient((prev) => {
      const next: Record<number, number[]> = {};
      nextClientTypeIds.forEach((id) => {
        if (prev[id]) next[id] = prev[id];
      });
      return next;
    });
  };

  const handleClientSubtypeChange = (
    clientTypeId: number,
    values: Array<string | number>,
  ) => {
    const groupIds =
      IntTplClientTypesList?.filter(
        (item) => item.clientTypeId === clientTypeId,
      ).map((item) => item.id) || [];
    const current = safeNumberArray(packagesState?.target?.clientSubtypeIds);
    const updated = mergeGroupSelection(current, groupIds, values);

    updatePackageTargetField("clientSubtypeIds", updated);
  };

  const handleClientDocumentTypeChange = (
    clientTypeId: number,
    values: Array<string | number>,
  ) => {
    const groupIds =
      IntTplClientDodumentTypesList?.filter(
        (item) => item.clientTypeId === clientTypeId,
      ).map((item) => item.id) || [];
    const current = safeNumberArray(
      packagesState?.target?.clientDocumentTypeIds,
    );
    const updated = mergeGroupSelection(current, groupIds, values);

    updatePackageTargetField("clientDocumentTypeIds", updated);
  };

  const handleCheck = (key: string, checked: boolean) => {
    const current = safeArray(packagesState?.target?.vehicleTypeIds).map(
      String,
    );
    const updated = checked
      ? [...current, key]
      : current.filter((k) => k !== key);

    updatePackageTargetField("vehicleTypeIds", updated.map(Number));
  };

  const allPurposeIds =
    IntTplPurposeList?.filter((x) => x.status === "active")?.map((p) => p.id) ||
    [];

  const initialData: Partial<DataType>[] =
    IntTplVehicleTypeList?.filter((v) => v.status === "active")?.map((v) => {
      const base = {
        key: `${v.id}`,
        label: `${v.translations?.[lang]?.name}`,
      };

      const dynamicFields = allPurposeIds.reduce((acc, id) => {
        acc[id] = v.usageTypeIds?.includes(id) || false;
        return acc;
      }, {} as Record<number, boolean>);

      return {
        ...base,
        ...dynamicFields,
      };
    }) || [];

  const columns: ColumnsType<Partial<DataType>> = [
    {
      title: "",
      dataIndex: "label",
      key: "label",
      render: (_, record) => (
        <Checkbox
          checked={safeArray(packagesState?.target?.vehicleTypeIds)
            .map(String)
            .includes(record?.key as string)}
          onChange={(e) => handleCheck(record.key as string, e.target.checked)}
        >
          {record.label}
        </Checkbox>
      ),
    },
    ...(IntTplPurposeList?.filter((x) => x.status === "active")?.map((p) => ({
      title: `${p?.translations?.[lang]?.name}`,
      dataIndex: `${p.id}`,
      key: `${p.id}`,
      align: "center" as "center",
      render: (value: boolean) =>
        value ? (
          <CheckOutlined style={{ color: "green", fontSize: 16 }} />
        ) : (
          <CloseOutlined style={{ color: "red", fontSize: 16 }} />
        ),
    })) || []),
  ];

  const _MainLoader =
    isPackagesLoading ||
    isCreatePackageLoading ||
    isDeletePackageLoading ||
    isUpdatePackageLoading;

  return (
    <>
      {_MainLoader ? (
        <Loader style={{ marginTop: 250 }} />
      ) : (
        <>
          {packages?.length === 0 && !isPackagesLoading ? (
            <Result
              icon={<SmileOutlined />}
              title={t("productPackagesNotFound")}
            />
          ) : (
            <Collapse
              accordion
              size="middle"
              onChange={(key) => {
                const _numberKey = Number(key);
                const _existingPackage = packages?.find(
                  (x) => x.id === _numberKey,
                );
                if (packages && key && _existingPackage) {
                  setPackagesState({
                    ..._existingPackage,
                    target: sanitizeTarget(_existingPackage.target),
                    paymentScheduleTypeIds: safeNumberArray(
                      _existingPackage.paymentScheduleTypeIds,
                    ),
                  });

                  const docSelections: Record<number, number[]> = {};
                  const selectedDocIds = safeNumberArray(
                    _existingPackage.target?.clientDocumentTypeIds,
                  );
                  clientTypes?.forEach((client) => {
                    const matchedDocs =
                      IntTplClientDodumentTypesList?.filter(
                        (docType) => docType.clientTypeId === client.id,
                      )?.map((docType) => docType.id) || [];
                    docSelections[client.id] = selectedDocIds.filter((id) =>
                      matchedDocs.includes(id),
                    );
                  });
                  setClientDocumentTypeSelectionsByClient(docSelections);
                } else {
                  setPackagesState({});
                  setClientDocumentTypeSelectionsByClient({});
                }
              }}
              items={packages?.map((item) => ({
                key: item.id.toString(),
                label: (
                  <Flex justify="space-between">
                    <Text>{item?.translations?.[lang]?.title}</Text>

                    <Text>
                      {item?.status === "draft" ? (
                        <Tag color="red">{t("inActive")}</Tag>
                      ) : (
                        <Tag color="blue">{t("active")}</Tag>
                      )}
                    </Text>
                  </Flex>
                ),

                children: (
                  <>
                    <Flex vertical gap={5}>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Text>{t("packageTitle")}</Text>
                        <Input
                          size="large"
                          placeholder=""
                          value={
                            packagesState?.translations?.[field_Language]?.title
                          }
                          onChange={(e) => {
                            updatePackageField("translations", {
                              ...packagesState?.translations,
                              [field_Language]: {
                                ...packagesState?.translations?.[
                                  field_Language
                                ],
                                title: e?.target?.value,
                              },
                            });
                          }}
                          width={"fullWidth"}
                        />
                      </Space>
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("numberOfDays")}
                      </Divider>

                      <Checkbox.Group
                        style={{ width: "100%" }}
                        value={safeNumberArray(
                          packagesState.target?.insurancePeriodIds,
                        )}
                        onChange={(checkedValues) =>
                          updatePackageTargetField(
                            "insurancePeriodIds",
                            normalizeNumberArray(checkedValues),
                          )
                        }
                      >
                        {/* checkedValues */}
                        <Card
                          size="small"
                          style={{ width: "100%" }}
                          loading={isDaysListLoading}
                        >
                          <Flex
                            gap={50}
                            justify="center"
                            align="center"
                            style={{ width: "100%" }}
                            wrap
                          >
                            {[...(daysList?.slice() || [])]
                              .filter((x) => x.status === "active")
                              ?.sort((a, b) => a.days - b.days)
                              ?.map((_day) => (
                                <Checkbox key={_day.id} value={_day?.id}>
                                  {_day.days}
                                </Checkbox>
                              ))}
                          </Flex>
                        </Card>
                      </Checkbox.Group>
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("clientTypes")}
                      </Divider>
                      {clientTypesLoading ? (
                        <Loader />
                      ) : (
                        <Flex vertical>
                          <Checkbox.Group
                            style={{ width: "100%" }}
                            value={safeNumberArray(
                              packagesState.target?.clientTypeIds,
                            )}
                            onChange={handleClientTypeChange}
                          >
                            <Flex
                              gap={20}
                              justify="space-around"
                              align="flex-start"
                              style={{ width: "100%" }}
                              wrap
                            >
                              {clientTypes?.map((_client) => {
                                const matchedInnerClientTypes =
                                  IntTplClientTypesList?.filter(
                                    (_clientType) =>
                                      _clientType.clientTypeId === _client.id,
                                  );

                                return (
                                  <Flex
                                    key={_client.id}
                                    vertical
                                    gap={10}
                                    style={{ width: "45%", minWidth: 300 }}
                                  >
                                    <Checkbox value={_client.id}>
                                      {_client.translations?.[lang]?.name}
                                    </Checkbox>

                                    <Card
                                      size="small"
                                      loading={isIntTplClientTypeListLoading}
                                    >
                                      <Checkbox.Group
                                        style={{
                                          width: "100%",
                                          maxHeight: 300,
                                          overflowY: "scroll",
                                        }}
                                        disabled={
                                          !safeNumberArray(
                                            packagesState.target?.clientTypeIds,
                                          ).includes(_client?.id)
                                        }
                                        value={safeNumberArray(
                                          packagesState.target
                                            ?.clientSubtypeIds,
                                        )}
                                        onChange={(checkedValues) =>
                                          handleClientSubtypeChange(
                                            _client.id,
                                            checkedValues,
                                          )
                                        }
                                      >
                                        <Flex gap={3} vertical>
                                          {matchedInnerClientTypes &&
                                          matchedInnerClientTypes?.length >
                                            0 ? (
                                            matchedInnerClientTypes?.map(
                                              (_clientType) => (
                                                <Checkbox
                                                  key={_clientType.id}
                                                  value={_clientType.id}
                                                >
                                                  {
                                                    _clientType.translations?.[
                                                      lang
                                                    ]?.name
                                                  }
                                                </Checkbox>
                                              ),
                                            )
                                          ) : (
                                            <div
                                              style={{
                                                color: "#888",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              არ მოიძებნა არცერთი ტიპი
                                            </div>
                                          )}
                                        </Flex>
                                      </Checkbox.Group>
                                    </Card>
                                  </Flex>
                                );
                              })}
                            </Flex>
                          </Checkbox.Group>
                        </Flex>
                      )}
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("clientDocumentTypes")}
                      </Divider>
                      <Flex vertical>
                        <Flex
                          gap={20}
                          justify="space-around"
                          align="flex-start"
                          style={{ width: "100%" }}
                          wrap
                        >
                          {clientTypes?.map((client) => {
                            const isClientTypeSelected = safeNumberArray(
                              packagesState.target?.clientTypeIds,
                            ).includes(client.id);

                            const noClientTypeSelected =
                              safeNumberArray(
                                packagesState.target?.clientTypeIds,
                              ).length === 0;

                            const matchedDocs =
                              IntTplClientDodumentTypesList?.filter(
                                (docType) => docType.clientTypeId === client.id,
                              );

                            return (
                              <Flex
                                key={client.id}
                                vertical
                                gap={10}
                                style={{ width: "45%", minWidth: 300 }}
                              >
                                <Text style={{ textAlign: "center" }}>
                                  {client.translations?.[lang]?.name}
                                </Text>

                                <Card
                                  size="small"
                                  loading={
                                    isIntTplClientDocumentTypeListLoading
                                  }
                                >
                                  <Checkbox.Group
                                    style={{ width: "100%" }}
                                    value={
                                      clientDocumentTypeSelectionsByClient[
                                        client.id
                                      ] || []
                                    }
                                    onChange={(values) => {
                                      const normalized =
                                        normalizeNumberArray(values);
                                      setClientDocumentTypeSelectionsByClient(
                                        (prev) => ({
                                          ...prev,
                                          [client.id]: normalized,
                                        }),
                                      );

                                      const allSelected = Object.entries({
                                        ...clientDocumentTypeSelectionsByClient,
                                        [client.id]: normalized,
                                      }).flatMap(([_, ids]) => ids);
                                      updatePackageTargetField(
                                        "clientDocumentTypeIds",
                                        normalizeNumberArray(allSelected),
                                      );
                                    }}
                                    disabled={
                                      !isClientTypeSelected ||
                                      noClientTypeSelected
                                    }
                                  >
                                    <Flex gap={3} vertical>
                                      {matchedDocs?.map((docType) => {
                                        const isEnabled =
                                          isClientTypeSelected &&
                                          !noClientTypeSelected &&
                                          docType.status === "active";
                                        return (
                                          <Checkbox
                                            key={`${client.id}-${docType.id}`}
                                            value={docType.id}
                                            disabled={!isEnabled}
                                            style={{
                                              cursor: isEnabled
                                                ? "pointer"
                                                : "not-allowed",
                                              opacity: isEnabled ? 1 : 0.6,
                                            }}
                                          >
                                            {docType.translations?.[lang]?.name}
                                          </Checkbox>
                                        );
                                      })}
                                    </Flex>
                                  </Checkbox.Group>
                                </Card>
                              </Flex>
                            );
                          })}
                        </Flex>
                      </Flex>

                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("purpose")}
                      </Divider>
                      <Flex vertical>
                        <Flex
                          gap={20}
                          justify="space-around"
                          align="flex-start"
                          style={{ width: "100%" }}
                          wrap
                        >
                          {clientTypes?.map((client) => {
                            const relatedPurposes = IntTplPurposeList?.filter(
                              (purpose) =>
                                purpose.status === "active" &&
                                purpose.clientTypeIds?.includes(client.id),
                            );

                            // Check if this client type is selected
                            const isClientTypeSelected = safeNumberArray(
                              packagesState.target?.clientTypeIds,
                            ).includes(client.id);

                            // If no client types are selected, disable all
                            const noClientTypeSelected =
                              safeNumberArray(
                                packagesState.target?.clientTypeIds,
                              ).length === 0;

                            return (
                              <Flex
                                key={client.id}
                                vertical
                                gap={10}
                                style={{ width: "45%", minWidth: 300 }}
                              >
                                <Text style={{ textAlign: "center" }}>
                                  {client.translations?.[lang]?.name}
                                </Text>

                                <Card
                                  size="small"
                                  loading={isIntTplPurposeLoading}
                                >
                                  <Checkbox.Group
                                    style={{ width: "100%" }}
                                    value={
                                      usageTypeSelectionsByClient[client.id] ||
                                      []
                                    }
                                    onChange={(values) =>
                                      handleUsageTypeChange(client.id, values)
                                    }
                                    disabled={
                                      !isClientTypeSelected ||
                                      noClientTypeSelected
                                    }
                                  >
                                    <Flex gap={3} vertical>
                                      {relatedPurposes?.map((purpose) => {
                                        // Checkbox is enabled only if client type is selected and at least one client type is selected
                                        const isEnabled =
                                          isClientTypeSelected &&
                                          !noClientTypeSelected &&
                                          purpose.status === "active";
                                        return (
                                          <Checkbox
                                            key={`${client.id}-${purpose.id}`}
                                            value={purpose.id}
                                            disabled={!isEnabled}
                                            style={{
                                              cursor: isEnabled
                                                ? "pointer"
                                                : "not-allowed",
                                              opacity: isEnabled ? 1 : 0.6,
                                            }}
                                          >
                                            {purpose.translations?.[lang]?.name}
                                          </Checkbox>
                                        );
                                      })}
                                    </Flex>
                                  </Checkbox.Group>
                                </Card>
                              </Flex>
                            );
                          })}
                        </Flex>
                      </Flex>
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("vehicleTypes")}
                      </Divider>
                      <Table
                        loading={
                          isIntTplVehicleTypeLoading || isIntTplPurposeLoading
                        }
                        columns={columns}
                        dataSource={initialData}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                        bordered
                      />
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("vehicleDocumentTypes")}
                      </Divider>

                      <Flex style={{ width: "100%" }}>
                        <Checkbox.Group
                          style={{ width: "100%" }}
                          value={safeNumberArray(
                            packagesState?.target?.vehicleDocumentTypeIds,
                          )}
                          onChange={(checkedValues) =>
                            updatePackageTargetField(
                              "vehicleDocumentTypeIds",
                              normalizeNumberArray(checkedValues),
                            )
                          }
                        >
                          <Card
                            size="small"
                            style={{ width: "100%" }}
                            loading={isIntTplVehicleDocumentTypesLoading}
                          >
                            <Flex
                              gap={10}
                              justify="center"
                              style={{ width: "100%" }}
                            >
                              {IntTplVehicleDodumentTypesList?.map(
                                (vehicleDocType) => (
                                  <Checkbox
                                    key={vehicleDocType.id}
                                    value={vehicleDocType?.id}
                                  >
                                    {vehicleDocType.translations?.[lang]?.name}
                                  </Checkbox>
                                ),
                              )}
                            </Flex>
                          </Card>
                        </Checkbox.Group>
                      </Flex>
                      {/*  */}
                      {isPaymentScheduleLoading ? (
                        <Loader />
                      ) : (
                        <>
                          <Divider
                            variant="dashed"
                            style={{
                              borderColor: Colors.blue,
                            }}
                          >
                            {t("paymentType")}
                          </Divider>

                          <Flex style={{ width: "100%" }}>
                            <Checkbox.Group
                              style={{ width: "100%" }}
                              value={safeNumberArray(
                                packagesState?.paymentScheduleTypeIds,
                              )}
                              onChange={(checkedValues) =>
                                updatePackageField(
                                  "paymentScheduleTypeIds",
                                  normalizeNumberArray(checkedValues),
                                )
                              }
                            >
                              <Card
                                size="small"
                                style={{ width: "100%" }}
                                loading={isPaymentScheduleLoading}
                              >
                                <Flex
                                  gap={20}
                                  justify="center"
                                  style={{ width: "100%" }}
                                >
                                  {paymentSchedule?.map((payment) => (
                                    <Checkbox
                                      key={payment.id}
                                      value={payment.id}
                                    >
                                      {payment.translations?.[lang]?.title}
                                    </Checkbox>
                                  ))}
                                </Flex>
                              </Card>
                            </Checkbox.Group>
                          </Flex>
                        </>
                      )}
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      >
                        {t("policyWording")}
                      </Divider>
                      <Flex gap={30} justify="space-evenly" wrap>
                        <DocumentFieldUploader
                          language="ka"
                          url={packagesState.wordingFiles?.ge?.url || ""}
                          onChange={(newUrl) => {
                            updatePackageField("wordingFiles", {
                              ...packagesState?.wordingFiles,
                              ge: {
                                ...packagesState?.wordingFiles?.ge,
                                url: newUrl,
                              },
                            });
                          }}
                          width={300}
                        />

                        <DocumentFieldUploader
                          language="en"
                          url={packagesState.wordingFiles?.en?.url || ""}
                          onChange={(newUrl) => {
                            updatePackageField("wordingFiles", {
                              ...packagesState?.wordingFiles,
                              en: {
                                ...packagesState?.wordingFiles?.en,
                                url: newUrl,
                              },
                            });
                          }}
                          width={300}
                        />
                      </Flex>
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      />
                      <Card type="inner" hoverable size="small">
                        <Flex
                          wrap
                          gap={20}
                          justify="space-around"
                          align="center"
                        >
                          <Tag color="blue">
                            <Space>
                              <Text>{t("createdDate")}:</Text>
                              <Text>
                                {dayjs(item.createdAt).format(
                                  "D / MM / YYYY | HH:mm:ss",
                                )}
                              </Text>
                            </Space>
                          </Tag>
                          <Tag color="geekblue">
                            <Space>
                              <Text>{t("lastUpdatedAt")}:</Text>
                              <Text>
                                {dayjs(item.updatedAt).format(
                                  "D / MM / YYYY | HH:mm:ss",
                                )}
                              </Text>
                            </Space>
                          </Tag>
                          <Tag color="blue">
                            <Space>
                              <Text>{t("status")}:</Text>
                              <Text
                                style={{
                                  color:
                                    item?.status === "published"
                                      ? "inherit"
                                      : Colors.primaryRed,
                                  letterSpacing: 2,
                                  textTransform: "uppercase",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.status}
                              </Text>
                            </Space>
                          </Tag>
                        </Flex>
                      </Card>
                      {/*  */}
                      <Divider
                        variant="dashed"
                        style={{
                          borderColor: Colors.blue,
                        }}
                      />
                      <Flex gap={20} vertical>
                        <Flex gap={20}>
                          <Button
                            type="primary"
                            size="large"
                            onClick={_UpdatePackage}
                            style={{ width: "100%" }}
                          >
                            {t("save")}
                          </Button>

                          {item?.status === "draft" ? (
                            <Button
                              type="default"
                              size="large"
                              onClick={() => _activePackageStatus("published")}
                              style={{ width: "100%" }}
                            >
                              {t("publish")}
                            </Button>
                          ) : null}
                        </Flex>

                        <Flex gap={20}>
                          {item?.status !== "draft" ? (
                            <Button
                              danger
                              type="default"
                              size="large"
                              onClick={() => _activePackageStatus("draft")}
                              style={{ width: "100%" }}
                            >
                              {t("moveToDraft")}
                            </Button>
                          ) : null}
                          <Popconfirm
                            title={t("certainToDeleteIt")}
                            onConfirm={() => _deletePackage(item?.id)}
                            onCancel={() => {}}
                            okText="Yes"
                            cancelText="No"
                            placement="bottom"
                          >
                            <Button
                              danger
                              type="dashed"
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {t("deletePackage")}
                            </Button>
                          </Popconfirm>
                        </Flex>
                      </Flex>
                    </Flex>
                  </>
                ),
              }))}
            />
          )}

          <Flex justify="center" style={{ marginTop: 20 }}>
            <Button
              style={{ width: "80%" }}
              type="dashed"
              size="large"
              onClick={_createPackage}
            >
              <PlusOutlined /> {t("addPackage")}
            </Button>
          </Flex>
        </>
      )}
    </>
  );
};

export default AdminInternationalTplPackageEdit;
